<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-16 10:14:50
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-12-27 16:34:17
-->
<template>
  <el-dialog
    class="addFromPaperDialog"
    title="从试卷列表选择"
    top="5vh"
    :visible.sync="addFormPaperVisible"
    width="960px"
  >
    <table-list
      v-if="addFormPaperVisible"
      :search-form="searchForm(this)"
      :data="paperList"
      :columns="columns(this)"
      :pager="pager"
      :options="{ singleCurrent: true }"
      @singleSelectChange="handleSingleChange"
      @search="onSearch"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <div class="footer">
      <el-button @click="addFormPaperVisible = false">取消</el-button>
      <el-button type="primary" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// 搜索框配置
const searchForm = _this => [
  {
    label: 'ID/试卷名称',
    prop: 'nameFilter',
  },
  {
    label: '职业',
    type: 'select',
    prop: 'jobId',
    children: _this.jobLevelList.map(item => ({
      value: item.id,
      label: item.jobName,
    })),
  },
  {
    label: '类型',
    type: 'select',
    prop: 'paperType',
    children: [
      { value: '1', label: '实操' },
      { value: '2', label: '理论' },
    ],
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'id',
    label: 'ID',
    minWidth: 70,
  },
  {
    prop: 'paperTitle',
    label: '试卷名称',
    minWidth: 180,
    twoLines: true,
  },
  {
    prop: 'paperJob',
    label: '适用职业',
    minWidth: 150,
  },
  {
    prop: 'jobLevel',
    label: '适用等级',
    minWidth: 70,
  },
  {
    prop: 'paperTypeStr',
    label: '适用类型',
    minWidth: 70,
  },
  {
    prop: 'questionTotal',
    label: '试题数',
    minWidth: 70,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 150,
  },
]
import { filterJobLevel, examPaperList, examSubjectBindPaper } from '@/api/exam'
import to from 'await-to'
import TableList from '@/components/TableList'
export default {
  name: 'AddFormPaper',
  components: { TableList },
  data() {
    return {
      searchForm,
      columns,
      addFormPaperVisible: false,
      jobLevelList: [],
      paperList: [],
      queryParams: {},
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      currentRow: {},
      id: '',
    }
  },
  methods: {
    show(id) {
      this.id = id
      this.queryParams = {}
      this.addFormPaperVisible = true
      this.getPaperList()
      this.getJobLevel()
    },
    async getJobLevel() {
      const [res, err] = await to(filterJobLevel({}))
      if (err) return this.$message.warning(err.msg)
      this.jobLevelList = res.data
    },
    async getPaperList() {
      const { current, size } = this.pager
      const [res, err] = await to(
        examPaperList({ current, size, ...this.queryParams, paperStatus: 2 }),
      )
      if (err) return this.$message.warning(err.msg)
      this.paperList = res.data.list
      this.pager.total = res.data.total
    },
    handleSingleChange(row) {
      this.currentRow = row
    },
    async save() {
      const [, err] = await to(
        examSubjectBindPaper({
          paperId: this.currentRow.id,
          planId: this.$route.params.id,
          id: this.id - 0,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.addFormPaperVisible = false
      this.$message.success('配置成功')
      this.$emit('success')
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      this.getPaperList()
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getPaperList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getPaperList()
    },
  },
}
</script>
<style lang="scss" scoped>
.addFromPaperDialog {
  /deep/ .el-table__body-wrapper {
    height: calc(100% - 102px) !important;
  }
  .footer {
    display: flex;
    padding-top: 16px;
    .el-button {
      &:first-child {
        margin-left: auto;
      }
    }
  }
}
</style>
